import { useState } from 'react';
import { OrganizationsApi } from '@/api/clients/organizations/organizations.api';

export const useUpdateManagedAccountMembership = () => {
  const [loading, setLoading] = useState(false);

  const updateMembership = async (
    organizationId,
    managed,
    confirmUnassignment = false,
  ) => {
    setLoading(true);
    try {
      return await OrganizationsApi.updateManagedAccountMembership(
        organizationId,
        managed,
        confirmUnassignment,
      );
    } finally {
      setLoading(false);
    }
  };

  return { updateMembership, loading };
};
